module.exports = __webpack_public_path__ + "static/media/21.a6b1b68f.png";